import * as React from 'react';
import { LeaderOfSales16 } from '@cian/ui-kit/icons';
import { Header0 } from '@cian/ui-kit/typography';
import * as style from './NewbuildingName.css';

export interface INewbuildingNameProps {
  name: string;
  isSalesLeader: boolean;
}

export const NewbuildingName: React.FC<INewbuildingNameProps> = props => {
  const { name, isSalesLeader } = props;

  return (
    <div className={style['name']}>
      <Header0 as={'h1'} fontWeight={'bold'} color="white_100">
        {name} {isSalesLeader && <LeaderOfSales16 color="warning_100" />}
      </Header0>
    </div>
  );
};
